const paramsSerializer = (
  params: Record<
    string,
    string | number | string[] | number[] | undefined | null
  >,
): string => {
  const searchParams = new URLSearchParams();
  for (const key in params) {
    const value = params[key];
    if (value !== undefined && value !== null) {
      if (Array.isArray(value)) {
        value.forEach(item => {
          if (item !== null) {
            searchParams.append(`${key}[]`, item.toString());
          } else if (item === null) {
            searchParams.append(`${key}[]`, item);
          }
        });
      } else {
        searchParams.append(key, value.toString());
      }
    }
  }

  return searchParams.toString();
};

export { paramsSerializer };
